// src/hooks/dashboard/locums/useGetAvailableLocums.ts

import { AxiosError } from 'axios';
import { useState } from 'react';
import useHttps from '../../useHttps';
import { availableLocumsActions } from '../../../redux/slices/availableLocumsSlice';
import {
  ErrorHttpResponse,
  PaginatedResponse,
  HttpConfig,
} from '../../../models/https';
import { useAppDisPatch } from '../../../redux/store';

interface AvailableLocumsFilter {
  page?: string;
  perPage?: string;
  location?: string;
  occupation?: string;
  keyword?: string;
}

const useGetAvailableLocums = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching available locums'
    );
  };

  const getAvailableLocums = (filter?: AvailableLocumsFilter) => {
    // parse pagination params or use defaults
    const page = parseInt(filter?.page ?? '1', 10) - 1;
    const perPage = parseInt(filter?.perPage ?? '10', 10);

    // build request URL
    let urlPath = `auth-service/users?isAvailableForWork=true&page=${page}&limit=${perPage}`;

    const loc = filter?.location?.toLowerCase() ?? '';

    const oc = filter?.occupation?.toLowerCase() ?? '';

    // Append search query parameters if provided
    if (filter?.location && loc !== 'any') {
      urlPath += `&state=${encodeURIComponent(filter.location)}`;
    }
    if (filter?.occupation && oc !== 'any') {
      urlPath += `&occupation=${encodeURIComponent(filter.occupation)}`;
    }
    if (filter?.keyword) {
      urlPath += `&firstName=${encodeURIComponent(filter.keyword)}`;
    }

    const config: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    const onSuccess = (response: PaginatedResponse) => {
      const {
        totalPages,
        totalElements,
        numberOfElements,
        first,
        last,
        content,
      } = response;

      dispatch(
        availableLocumsActions.updateAvailableLocums({
          page,
          perPage,
          totalPages,
          totalElements,
          numberOfElements,
          first,
          last,
          content,
        })
      );
    };

    return request(config, onSuccess, setLoading, onError);
  };

  return { getAvailableLocums, loading };
};

export default useGetAvailableLocums;
